
export const SALES_FORECAST_POSTING = (state, value) => {
  state.salesForecastPosting = value
}

export const SALES_FORECAST_ERRORS = (state, value) => {
  state.salesForecastErrors = value
}

export const SALES_FORECAST_TOTALS = (state, value) => {
  state.salesForecastTotals = value
}

export const SALES_FORECAST_POSTED = (state, value) => {
  state.salesForecastPosted = value
}


export const MAIN_LIST_QUICK_FILTER = (state, value) => {
  state.mainListQuickFilters = value
}

export const QUICK_FILTERS_DATES_FROM = (state, value) => {
  state.quickFiltersDatesFrom = value
}

export const QUICK_FILTERS_DATES_TO = (state, value) => {
  state.quickFiltersDatesTo = value
}